import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getListLottery = (params) => {
    return axios.get(`${backendHost}/api/admin/lottery/list`, {params});
};

export {
    getListLottery
}